﻿

export function jobListingClickEvent() {
  function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
    var startTimeInMs = Date.now();
    (function loopSearch() {
      if (document.querySelector(selector) != null) {
        callback();
        return;
      }
      else {
        setTimeout(function () {
          if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
            return;
          loopSearch();
        }, checkFrequencyInMs);
      }
    })();
  }
  waitForElementToDisplay(".BambooHR-ATS-Jobs-Item", function() {
    document.querySelectorAll(".BambooHR-ATS-Jobs-Item").forEach(function(item) {
      var url = item.querySelector("a").href
      item.addEventListener("click", function () {
        window.location.href = url
      });
    })
  }, 1000,9000);
}